export type CookieYes = {
  activeLaw: string
  categories: {
    necessary: boolean
    functional: boolean
    analytics: boolean
    performance: boolean
    advertisement: boolean
  }
  isUserActionCompleted: boolean
  consentID: string
  languageCode: string
}

export type CookieCategory = keyof CookieYes["categories"]

declare global {
  interface Window {
    getCkyConsent?: () => CookieYes
  }
}

export const consentForCategory = (category: CookieCategory): boolean => {
  if (window.getCkyConsent) {
    const consent = window.getCkyConsent()

    return consent.categories[category]
  }

  return false
}
